import io from "socket.io-client";


//const socket = io('http://172.20.10.5:8000');
const socket = io('https://cdn.song-quiz.de');


export { socket }